import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Layout } from '../components/Layout';
export function ContactPage() {
  const scrollToForm = () => {
    const formElement = document.getElementById('quote-form');
    if (formElement) {
      formElement.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const categories = [];
  return <Layout data-id="element-272">
      {/* Hero Section */}
      <section className="relative h-[40vh] md:h-[30vh] flex items-center justify-center overflow-hidden" data-id="element-273">
        <div className="absolute inset-0 z-0" data-id="element-274">
          <img src="https://cdn.magicpatterns.com/uploads/eEe9VsmrA3SeUKnX2GxCoz/image.png" alt="Quotes Background" className="w-full h-full object-cover brightness-[0.5]" data-id="element-275" />
          <div className="absolute inset-0 bg-black/20" data-id="element-276" />
        </div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="relative z-10 text-4xl md:text-6xl font-bold text-white uppercase tracking-tighter text-center" data-id="element-277">
          Get in Touch
        </motion.h1>
      </section>

      {/* Category Grid Section */}
      <section className="px-6 bg-white" data-id="element-278">
        <div className="max-w-7xl mx-auto" data-id="element-279">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16" data-id="element-280">
            {categories.map((category, idx) => <Link key={idx} to="/showroom" className="block group" data-id="element-281">
                <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: idx * 0.1
            }} className="flex flex-col items-center text-center cursor-pointer" data-id="element-282">
                  <div className="aspect-square w-full overflow-hidden bg-[#F5F5F5] mb-6 border border-charcoal/5" data-id="element-283">
                    <img src={category.image} alt={category.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" data-id="element-284" />
                  </div>
                  <h3 className="text-xl font-black text-[#6B0D24] uppercase tracking-tight" data-id="element-285">
                    {category.title}
                  </h3>
                </motion.div>
              </Link>)}
          </div>
        </div>
      </section>

      {/* Content Section - Form and Map */}
      <section id="quote-form" className="py-12 px-6 bg-alabaster border-t border-charcoal/5" data-id="element-286">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-start" data-id="element-287">
          {/* Left Column: Form */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-288">
            <h2 className="text-4xl font-black text-[#6B0D24] mb-8" data-id="element-289">
              Send Us A Message
            </h2>

            <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-290">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-291">
                <input type="text" placeholder="First Name" className="w-full bg-[#F5F5F5] border border-charcoal/5 px-6 py-4 outline-none focus:border-[#6B0D24] transition-colors" data-id="element-292" />
                <input type="text" placeholder="Last Name" className="w-full bg-[#F5F5F5] border border-charcoal/5 px-6 py-4 outline-none focus:border-[#6B0D24] transition-colors" data-id="element-293" />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-294">
                <input type="email" placeholder="Your Email" className="w-full bg-[#F5F5F5] border border-charcoal/5 px-6 py-4 outline-none focus:border-[#6B0D24] transition-colors" data-id="element-295" />
                <input type="tel" placeholder="Phone Number" className="w-full bg-[#F5F5F5] border border-charcoal/5 px-6 py-4 outline-none focus:border-[#6B0D24] transition-colors" data-id="element-296" />
              </div>

              <input type="text" placeholder="Address" className="w-full bg-[#F5F5F5] border border-charcoal/5 px-6 py-4 outline-none focus:border-[#6B0D24] transition-colors" data-id="element-297" />

              <textarea placeholder="Enter Your Message" rows={6} className="w-full bg-[#F5F5F5] border border-charcoal/5 px-6 py-4 outline-none focus:border-[#6B0D24] transition-colors resize-none" data-id="element-298"></textarea>

              <button className="bg-[#6B0D24] text-white px-12 py-4 font-black uppercase tracking-[0.2em] text-sm hover:bg-[#5A0B1E] transition-colors" data-id="element-299">
                Submit
              </button>
            </form>
          </motion.div>

          {/* Right Column: Map */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="h-[500px] lg:h-[650px] w-full border border-charcoal/5 shadow-2xl overflow-hidden" data-id="element-300">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3098.375548052479!2d-76.6975!3d39.13!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b7e9!2s1807%20Oriole%20Ct%2C%20Severn%2C%20MD%2021144!5e0!3m2!1sen!2sus!4v1716912000000!5m2!1sen!2sus" width="100%" height="100%" style={{
            border: 0
          }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="NK Home Improvement Location" data-id="element-301"></iframe>
          </motion.div>
        </div>
      </section>
    </Layout>;
}